/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleSummary } from './APIArticleSummary';
import {
    APIArticleSummaryFromJSON,
    APIArticleSummaryFromJSONTyped,
    APIArticleSummaryToJSON,
} from './APIArticleSummary';
import type { APIPosition } from './APIPosition';
import {
    APIPositionFromJSON,
    APIPositionFromJSONTyped,
    APIPositionToJSON,
} from './APIPosition';

/**
 * 
 * @export
 * @interface APIStorageArticleSearchResult
 */
export interface APIStorageArticleSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResult
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    comment?: string;
    /**
     * 
     * @type {APIPosition}
     * @memberof APIStorageArticleSearchResult
     */
    position?: APIPosition | null;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    positionName?: string;
    /**
     * 
     * @type {APIArticleSummary}
     * @memberof APIStorageArticleSearchResult
     */
    article?: APIArticleSummary | null;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    articleNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    articleName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResult
     */
    sharedRequestId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResult
     */
    guestRequestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    guestRequestEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIStorageArticleSearchResult interface.
 */
export function instanceOfAPIStorageArticleSearchResult(value: object): value is APIStorageArticleSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIStorageArticleSearchResultFromJSON(json: any): APIStorageArticleSearchResult {
    return APIStorageArticleSearchResultFromJSONTyped(json, false);
}

export function APIStorageArticleSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStorageArticleSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'position': json['position'] == null ? undefined : APIPositionFromJSON(json['position']),
        'positionName': json['position_name'] == null ? undefined : json['position_name'],
        'article': json['article'] == null ? undefined : APIArticleSummaryFromJSON(json['article']),
        'articleNumber': json['article_number'] == null ? undefined : json['article_number'],
        'articleName': json['article_name'] == null ? undefined : json['article_name'],
        'sharedRequestId': json['shared_request_id'] == null ? undefined : json['shared_request_id'],
        'guestRequestId': json['guest_request_id'] == null ? undefined : json['guest_request_id'],
        'guestRequestEmail': json['guest_request_email'] == null ? undefined : json['guest_request_email'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIStorageArticleSearchResultToJSON(value?: APIStorageArticleSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'amount': value['amount'],
        'comment': value['comment'],
        'position': APIPositionToJSON(value['position']),
        'position_name': value['positionName'],
        'article': APIArticleSummaryToJSON(value['article']),
        'article_number': value['articleNumber'],
        'article_name': value['articleName'],
        'shared_request_id': value['sharedRequestId'],
        'guest_request_id': value['guestRequestId'],
        'guest_request_email': value['guestRequestEmail'],
        'root_account_id': value['rootAccountId'],
    };
}

